/* eslint-disable import/order */
import { issueHierarchyPageResource } from '@jira/admin-pages__issue-types-issue-hierarchy-directory/src/issueHierarchyPageResource.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssueHierarchyRoute } from '@jira/router-routes__admin-pages-issue-types-routes/src/globalSettingsIssueHierarchyRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import IssueHierarchyDirectory, {
	LazyIssueHierarchyDirectory,
} from './ui/spa/admin-pages/issue-types/issue-hierarchy-directory/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsIssueHierarchyRouteEntry: Route = createEntry(
	globalSettingsIssueHierarchyRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.issue-hierarchy-config',
		// eslint-disable-next-line no-restricted-syntax
		component: IssueHierarchyDirectory,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			issueHierarchyPageResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyIssueHierarchyDirectory],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
